(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const searchEl = document.querySelector('#q');
  const predictiveSearchSection = document.querySelector('#predictive-search-results-container');
  let controller = null;

  function doSearch() {
    if (controller) {
      controller.abort();
    }

    const term = searchEl.value;

    if (term.trim() === '') {
      predictiveSearchSection.innerHTML = '';
      return;
    }

    controller = new AbortController();
    const signal = controller.signal;

    let requestResponse;
    fetch(`${window.Shopify.routes.root}search/suggest?q=${term}&resources[type]=query,product&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=hide&section_id=predictive-search`, {
      signal
    })
      .then((response) => {
        requestResponse = response;
        return response.text();
      })
      .then((text) => {
        if (!requestResponse.ok) {
          throw new Error(`${requestResponse.status}: ${text}`);
        }

        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;

        predictiveSearchSection.innerHTML = resultsMarkup;
      })
      .catch((error) => {
        if (error.name !== 'AbortError') {
          console.error(error);
        }
      });
  }

  searchEl.addEventListener('keyup', function(e) {
    if (e.key === 'Escape') {
      predictiveSearchSection.innerHTML = '';
      return;
    }
    doSearch();
  });

  searchEl.addEventListener('input', function() {
    if (searchEl.value.trim() === '') {
      predictiveSearchSection.innerHTML = '';
    }
  });

  document.body.addEventListener('focusin', function(el) {
    if (!el.target.closest('#search-form') && predictiveSearchSection.children.length) {
      predictiveSearchSection.innerHTML = '';
    }
  });

  document.body.addEventListener('click', function(el) {
    if (!el.target.closest('#search-form') && predictiveSearchSection.children.length) {
      predictiveSearchSection.innerHTML = '';
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knitting-yarn-info"] && !Shopify.designMode) return;
  try {
    
// Add your scripts here

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-menu"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      // Animate elements when page loads
      const animateElements = document.querySelectorAll('#main-menu .sub-menu');

      setTimeout(() => {
        animateElements.forEach((element, index) => {
          setTimeout(() => {
            element.classList.add('animate-fade-in');
            element.style.opacity = "1";
            element.style.transform = "translateY(0)";
          }, index * 150);
        });
      }, 300);

      const findMatchingSidebarMenu = (targetUrl, sidebar) => {
        if (!sidebar) return null;

        const allDetails = sidebar.querySelectorAll('details[name="menu"][data-menu-item-url]');

        for (let details of allDetails) {
          const menuItemUrl = details.getAttribute('data-menu-item-url');
          if (menuItemUrl === targetUrl) {
            return details;
          }
        }
        return null;
      };

      const openSidebarWithMenu = (linkUrl) => {
        const sidebar = document.querySelector('#sidebar');
        if (!sidebar) return;
 
        const matchingDetails = findMatchingSidebarMenu(linkUrl, sidebar);
        
        if (matchingDetails) {
          sidebar.showModal();
          matchingDetails.open = true;
          return true;
        }

        return false;
      };

      const mainMenuLinks = document.querySelectorAll('#main-nav a');
      mainMenuLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          let cleanUrl = e.currentTarget.pathname;
          if (cleanUrl == document.location.pathname && e.currentTarget.hash) {
            cleanUrl = e.currentTarget.hash.substring(1);
          }
          if (openSidebarWithMenu(cleanUrl)) {
            e.preventDefault();
          }
        });
      });

      // Auto-open first menu item when desktop hamburger is clicked
      const hamburgerBtns = document.querySelectorAll('#main-nav button[commandfor="sidebar"], .header-menu');
      hamburgerBtns.forEach(hamburgerBtn => {
        hamburgerBtn.addEventListener('click', () => {
          const sidebar = document.querySelector('#sidebar');
          if (!sidebar) return;
          if (window.screen.width >= 740) {
            const firstDetails = sidebar.querySelector('details[name="menu"]');
            if (firstDetails) firstDetails.open = true;
          }
        });
      })
    });
  
  } catch(e) { console.error(e); }
})();
})();
